// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { LoggedInDto, ResultDataOfNullableGuid, AuthResponseDto, AuthAttemptDto, ResetPasswordWithCheckRequestDto, ResetPasswordRequestDto, ResetPasswordDto } from "../../types";
import type { UseApiFetchOptions, UseApiFetchResponse } from "../../composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { Ref, MaybeRef } from "vue";
import {
    $apiFetch,
    computed,
    unref,
    useApiFetch,
    useFetchDependencies
} from "#imports";

export function useAuthResource () {


    /**
     * Check authentication status, if we are authenticated make sure who the client
    thinks is logged in as who is actually logged in
     * @param webAccountId (optional) 
     * @return Authentication status
     */
    function isLoggedIn(
        webAccountId?: MaybeRef<string | null | undefined>
    ) : UseApiFetchResponse<LoggedInDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/Auth/isLoggedIn?";

        const webAccountIdUnref = unref( webAccountId );
        if (webAccountIdUnref !== undefined && webAccountIdUnref !== null)
            url_ += "webAccountId=" + encodeURIComponent("" + webAccountIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<LoggedInDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<LoggedInDto>( computedUrl, options_ );
    }


    /**
     * Check the password reset key
     * @param resetKey (optional) A password reset key
     * @return The GUID of the web account the reset key belongs to
                along with any status information
     */
    function checkPasswordResetKey(
        resetKey?: MaybeRef<string | undefined>
    ) : UseApiFetchResponse<ResultDataOfNullableGuid> {
        const computedUrl = computed( () => {
          let url_ = "/api/Auth/check-pw-reset?";

        const resetKeyUnref = unref( resetKey );
        if (resetKeyUnref === null)
            throw new Error("The parameter 'resetKey' cannot be null.");
        else if (resetKeyUnref !== undefined)
            url_ += "resetKey=" + encodeURIComponent("" + resetKeyUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<ResultDataOfNullableGuid> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<ResultDataOfNullableGuid>( computedUrl, options_ );
    }


    /**
     * Switch to the supplied web account ID and log them in
     * @param webAccountId (optional) The ID of the web account to switch to
     * @return Authentication data
     */
    function switchAccount(
        webAccountId?: MaybeRef<string | undefined>
    ) : UseApiFetchResponse<AuthResponseDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/Auth/switch-account?";

        const webAccountIdUnref = unref( webAccountId );
        if (webAccountIdUnref === null)
            throw new Error("The parameter 'webAccountId' cannot be null.");
        else if (webAccountIdUnref !== undefined)
            url_ += "webAccountId=" + encodeURIComponent("" + webAccountIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<AuthResponseDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<AuthResponseDto>( computedUrl, options_ );
    }

    return {
        isLoggedIn,
        checkPasswordResetKey,
        switchAccount,
    }
}


export function $authResource () {

    const dependencies_ = useFetchDependencies();

    /**
     * Attempt to sign the user in
     * @param authAttempt (optional) The details the user has supplied
     * @return 200 if successful
     */
    function logIn(
        authAttempt?: AuthAttemptDto | undefined
    ) {
        let url_ = "/api/Auth/login";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = authAttempt;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "POST",
        };

        return $apiFetch<AuthResponseDto>( url_, options_, dependencies_ );
    }

    /**
     * Sign the current user out
     * @return 200 if successful
     */
    function logOut(
        
    ) {
        let url_ = "/api/Auth/logout";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Check authentication status, if we are authenticated make sure who the client
    thinks is logged in as who is actually logged in
     * @param webAccountId (optional) 
     * @return Authentication status
     */
    function isLoggedIn(
        webAccountId?: string | null | undefined
    ) {
        let url_ = "/api/Auth/isLoggedIn?";

        const webAccountIdUnref = unref( webAccountId );
        if (webAccountIdUnref !== undefined && webAccountIdUnref !== null)
            url_ += "webAccountId=" + encodeURIComponent("" + webAccountIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<LoggedInDto>( url_, options_, dependencies_ );
    }

    /**
     * Resets the current user's password with an authentication check
     * @return True, if successul
     */
    function resetPasswordWithCheck(
        resetRequest: ResetPasswordWithCheckRequestDto
    ) {
        let url_ = "/api/Auth/send-pw-reset-with-check";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = resetRequest;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Generate and send a password reset email
     * @param resetPasswordRequest Request details for resetting a password
     * @return True if the email was sent
     */
    function sendPasswordResetEmail(
        resetPasswordRequest: ResetPasswordRequestDto
    ) {
        let url_ = "/api/Auth/send-pw-reset";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = resetPasswordRequest;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Check the password reset key
     * @param resetKey (optional) A password reset key
     * @return The GUID of the web account the reset key belongs to
                along with any status information
     */
    function checkPasswordResetKey(
        resetKey?: string | undefined
    ) {
        let url_ = "/api/Auth/check-pw-reset?";

        const resetKeyUnref = unref( resetKey );
        if (resetKeyUnref === null)
            throw new Error("The parameter 'resetKey' cannot be null.");
        else if (resetKeyUnref !== undefined)
            url_ += "resetKey=" + encodeURIComponent("" + resetKeyUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<ResultDataOfNullableGuid>( url_, options_, dependencies_ );
    }

    /**
     * Reset a password
     * @param resetPassword Reset password request data
     * @return True if the password was reset
     */
    function resetPassword(
        resetPassword: ResetPasswordDto
    ) {
        let url_ = "/api/Auth/reset-password";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = resetPassword;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Switch to the supplied web account ID and log them in
     * @param webAccountId (optional) The ID of the web account to switch to
     * @return Authentication data
     */
    function switchAccount(
        webAccountId?: string | undefined
    ) {
        let url_ = "/api/Auth/switch-account?";

        const webAccountIdUnref = unref( webAccountId );
        if (webAccountIdUnref === null)
            throw new Error("The parameter 'webAccountId' cannot be null.");
        else if (webAccountIdUnref !== undefined)
            url_ += "webAccountId=" + encodeURIComponent("" + webAccountIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<AuthResponseDto>( url_, options_, dependencies_ );
    }

    return {
        logIn,
        logOut,
        isLoggedIn,
        resetPasswordWithCheck,
        sendPasswordResetEmail,
        checkPasswordResetKey,
        resetPassword,
        switchAccount,
    }
}